import React from 'react';
import { wrapWithCurationsIndexHealthProvider } from '@apps/registry/common/components/Catalog/routes/CurationsIndex/CurationsIndex.health';
import { Seo } from '@shared/components/Seo';
import { useTranslation } from '@shared/core';
import { ContentGridContainer } from '../../components/ContentGridContainer';
import { CurationCardGrid } from '../../components/CurationCard';
import { Page } from '../../components/LayoutStructure';
import { useCatalogContext } from '../../state/Catalog';
import { CurationHeroHeader } from './components/CurationHeroHeader/CurationHeroHeader';
import { useCurationsIndexController } from './CurationsIndex.controller';
import { Box } from '@withjoy/joykit';
import { HeroTextWithSkeleton } from '../../components/HeroText/HeroText';
import { useShopStorefrontContext } from '../../components/ShopStorefrontProvider';

export const CurationsIndex = wrapWithCurationsIndexHealthProvider(() => {
  const { curations, heroText, isLoadingTreeRootData, showSkeleton } = useCurationsIndexController();
  const { t } = useTranslation('catalogRegistry');
  const { eventId } = useCatalogContext();
  const { currentStorefront } = useShopStorefrontContext();
  const seoTrans = t('seo', currentStorefront);

  return (
    <Page paddingTop={undefined}>
      <Seo title={seoTrans.shopCurationIndexTitle()} description={seoTrans.shopCurationIndexDescription()} />
      <CurationHeroHeader eventId={eventId} />
      <Box paddingTop={[8, null, 0]} paddingX={[6, null, 0]}>
        <HeroTextWithSkeleton skeletonRowCount={3} heroText={heroText} shouldRevealSkeleton={!isLoadingTreeRootData || !!heroText} />
      </Box>
      <ContentGridContainer showSideBar={false}>
        <CurationCardGrid curations={curations} showSkeleton={showSkeleton} telemetryPageValue="curationRoot" />
      </ContentGridContainer>
    </Page>
  );
});

CurationsIndex.displayName = 'CurationsIndex';
